import { render, staticRenderFns } from "./SelectStudentInput.vue?vue&type=template&id=72c3e6f6&scoped=true"
import script from "./SelectStudentInput.vue?vue&type=script&lang=ts"
export * from "./SelectStudentInput.vue?vue&type=script&lang=ts"
import style0 from "./SelectStudentInput.vue?vue&type=style&index=0&id=72c3e6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3e6f6",
  null
  
)

export default component.exports